









/** @format */

import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'PassRule',
  components: {
    PassRuleEdit: () => import('./components/pass-rule-edit.vue')
  }
})
export default class PassRule extends Vue {
  // Type
  @Prop({ type: String, default: '' })
  type!: string;

  // 机构ID
  @Prop({ type: String, default: '' })
  organizationId!: string;

  // 车场ID
  @Prop({ type: String, default: '' })
  parkId!: string;

  created() {}

  mounted() {}
}
